// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import JRPackage from '../_raw/service/icon_JRPackage.svg';
import withIconProps from '../withIconProps';

export default withIconProps(JRPackage);
